// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"724":"aadb9e9b","761":"a2be9a31"}[chunkId] + ".chunk.js";
};